import type { ConfiguracaoFiscalModel } from "../models/configuracaoFiscalModel"

export enum ConfiguracaoFiscalActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    TOGGLE_FORMA = "TOGGLE_FORMA",
}

type CarregarAction = {
    type: ConfiguracaoFiscalActionsTypes.CARREGAR
    payload: ConfiguracaoFiscalModel
}

type AtualizarCampoAction = {
    type: ConfiguracaoFiscalActionsTypes.ATUALIZAR_CAMPO
    payload: { campo: keyof ConfiguracaoFiscalModel; valor: string | boolean }
}

type ToggleFormaAction = {
    type: ConfiguracaoFiscalActionsTypes.TOGGLE_FORMA
    payload: { id: number }
}

export type ConfiguracaoFiscalAction = CarregarAction | AtualizarCampoAction | ToggleFormaAction
